import { CalendarSection } from '../../features/Calendar'
import './styles.scss'

export const CalendarContainer = () => (
  <div className="calendar-page-container">
    <CalendarSection />
  </div>
)
